function removeEmpty(obj): any {
  if (Array.isArray(obj)) {
    const filtered = obj
      .map(item => removeEmpty(item))
      .filter(item => typeof item !== 'undefined' && item !== null);

    return filtered.length ? filtered : undefined;
  }

  if (obj && typeof obj === 'object') {
    const newObj = {};
    Object.keys(obj).forEach((k) => {
      const cleaned = removeEmpty(obj[k]);
      if (typeof cleaned !== 'undefined' && cleaned !== null) {
        newObj[k] = cleaned;
      }
    });

    return Object.keys(newObj).length ? newObj : undefined;
  }

  return obj;
}

function encodeValue(value: any): string {
  if (value === null || typeof value === 'undefined') {
    return '';
  }

  if (typeof value === 'object') {
    return encodeURIComponent(JSON.stringify(value));
  }

  return encodeURIComponent(String(value));
}


export function objectToQueryParams(obj: object): string {
  const notEmpty = obj && typeof obj !== 'undefined' && Object.keys(obj).length > 0;

  if (notEmpty) {
    obj = removeEmpty(obj);
    const params = Object.keys(obj).flatMap((key) => {
      const value = obj[key];
      if (Array.isArray(value)) {
        return value.map((item) => `${encodeURIComponent(key)}=${encodeValue(item)}`);
      }

      return `${encodeURIComponent(key)}=${encodeValue(value)}`;
    });

    return `?${params.join('&')}`;
  }

  return '';
}
